export function About() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-light text-neutral-900 mb-8 text-center">About Us</h2>
        <p className="text-lg text-neutral-700 leading-relaxed text-center">
          AK-KUR Furniture & Fitting Ltd is a UK-based wholesale supplier specialising in
          furniture, carpets and lighting equipment. We work with businesses, contractors and
          designers to deliver reliable, high-quality interior solutions.
        </p>
      </div>
    </section>
  );
}
